import { CLIENT_CHART_ALLOWED_SUBTONES } from "../consts/charts.consts"

export default class Component {
  static classNames(...args) {
    if (args) {
      let classes = []

      for (let i = 0; i < args.length; i++) {
        const className = args[i]

        if (!className) continue

        const type = typeof className

        if (type === "string" || type === "number") {
          classes.push(className)
        } else if (type === "object") {
          const _classes =
            Array.isArray(className) ? className : (
              Object.entries(className).map(([key, value]) =>
                value ? key : null
              )
            )

          classes =
            _classes.length ?
              classes.concat(_classes.filter((c) => !!c))
            : classes
        }
      }

      return classes.join(" ")
    }

    return undefined
  }
}

export const getElementFullHeight = (element) => {
  if (!element) return 0
  const styles = window.getComputedStyle(element)
  const marginTop = parseFloat(styles.marginTop)
  const marginBottom = parseFloat(styles.marginBottom)
  const totalHeight = element.offsetHeight + marginTop + marginBottom
  return totalHeight
}

export const getAllCSSVariableNames = (styleSheets = document.styleSheets) => {
  const cssVars = []
  for (let i = 0; i < styleSheets.length; i++) {
    try {
      for (let j = 0; j < styleSheets[i].cssRules.length; j++) {
        try {
          for (let k = 0; k < styleSheets[i].cssRules[j].style.length; k++) {
            const name = styleSheets[i].cssRules[j].style[k]
            if (name.startsWith("--") && cssVars.indexOf(name) === -1) {
              cssVars.push(name)
            }
          }
        } catch (error) {}
      }
    } catch (error) {}
  }
  return cssVars
}

export const getElementCSSVariables = (
  allCSSVars,
  element = document.body,
  pseudo
) => {
  const elStyles = window.getComputedStyle(element, pseudo)
  const cssVars = {}
  for (var i = 0; i < allCSSVars.length; i++) {
    const key = allCSSVars[i]
    const value = elStyles.getPropertyValue(key)
    if (value) {
      cssVars[key] = value
    }
  }
  return cssVars
}

export const getPieChartColorSubtone = (color, index) => {
  if (!color) return "var(--blue-600)"
  const allowedSubtones = CLIENT_CHART_ALLOWED_SUBTONES
  const cssVars = getAllCSSVariableNames()
  const hexColorVars = getElementCSSVariables(cssVars, document.documentElement)
  const targetColor = color.trim().toLowerCase()
  const variableName = Object.keys(hexColorVars).find(
    (key) => hexColorVars[key].trim().toLowerCase() === targetColor
  )
  if (variableName) {
    const baseVariableName = variableName.replace(/-\d+$/, "")

    const fullLength = allowedSubtones.length
    const cycle = Math.floor(index / (fullLength - 1))
    const position = index % (fullLength - 1)

    let subtone = ""
    if (cycle % 2 === 0) {
      subtone = allowedSubtones[position]
    } else {
      subtone = allowedSubtones[fullLength - 1 - position]
    }

    return `var(${baseVariableName}-${subtone})`
  }
  return color
}
